module.exports = __webpack_public_path__ + "static/media/calendar-img.f3d89541.png";